<template>
  <b-modal
    :title="`Enviar expediente #${file.numero} a DocDigital`"
    v-model="showModal"
    size="lg"
    hide-footer
    centered
    no-close-on-backdrop
  >
    <b-overlay :show="loading">
      <div class="row">
        <div class="col-12 text-center">
          <h3>
            Estás a punto de enviar el expediente hacia DocDigital, una vez enviado
            no habrá vuelta atrás
          </h3>
        </div>
        <div class="col-12 mt-3">
          <b-form-group
            v-if="matterEmpty"
            label="Materia"
            label-for="matter-input"
          >
            <b-form-textarea
              id="matter-input"
              v-model="matterInput"
              v-validate="'required|max:150'"
              data-vv-scope="send-to-docdigital-form"
              data-vv-name="matter"
              data-vv-as="Materia"
              placeholder="Ejemplo: Recaudo de impuestos"
              :maxlength="150"
              rows="2"
              max-rows="4"
            ></b-form-textarea>
            <small class="form-text text-muted text-right d-block">
              {{ matterInput.length }} / 150
            </small>
            <b-form-invalid-feedback>
              La materia es obligatoria (máximo 150 caracteres).
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-12 text-right  mt-5">
          <b-button
            @click="sendExpToDocDigital"
            data-cy="send-docdigital"
            variant="primary"
          >
            Enviar a DocDigital
          </b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import { listOptions, listV2Options } from '@/febos/servicios/api/opciones.api';

export default {
  name: 'PopUpSendToDocDigital',
  components: {},
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      entitiesIds: [],
      matterInput: '',
      matterEmpty: false,
      docDigital: {
        description: 'Enviado desde Escritorio Digital',
        documentType: '',
        isPrivate: false,
        matter: '',
        subjects: [],
        subjectsSelected: [],
        copies: [],
        copiesSelected: [],
        document: '',
        attachedDocuments: ''
      },
      maxChar: 255,
      optionsIsPrivate: [
        { label: 'Si', value: true },
        { label: 'No', value: false }
      ],
      loadingToSend: false
    };
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Dnts', [
      'detailsFile'
    ]),
    ...mapGetters('docDigital', [
      'documentType',
      'entity',
      'loading'
    ]),
    showModal: {
      get() {
        return this.modalName === 'sendToDocDigital';
      },
      set() {
        this.docDigital = {
          description: '',
          documentType: '',
          isPrivate: false,
          matter: this.detailsFile.observaciones[0].observacion,
          subjects: [],
          subjectsSelected: [],
          copies: [],
          copiesSelected: [],
          document: '',
          attachedDocuments: ''
        };
        this.matterInput = '';
        this.matterEmpty = false;
        this.closeModal();
      }
    }
  },
  watch: {
    async detailsFile(newVal) {
      if (newVal) {
        await this.loadData();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('docDigital', [
      'sendToDocDigital'
    ]),
    async addSubject(row) {
      const isSelected = this.docDigital.subjectsSelected
        .some((subjectRow) => subjectRow.subjectUser.value === row.subjectUser.value);

      if (!isSelected) {
        console.log(this.docDigital.subjects);
        this.docDigital.subjects.push(row);
        this.docDigital.subjectsSelected.push(row);
      } else {
        this.$vs.notify({
          title: '¡Oye!',
          text: 'Ya agregaste este destinatario',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          position: ALERT_POSITION
        });
      }
    },
    async addCopy(row) {
      const isSelected = this.docDigital.copiesSelected
        .some((subjectRow) => subjectRow.subjectUser.value === row.subjectUser.value);

      if (!isSelected) {
        this.docDigital.copies.push(row);
        this.docDigital.copiesSelected.push(row);
      } else {
        this.$vs.notify({
          title: '¡Oye!',
          text: 'Ya agregaste esta copia',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          position: ALERT_POSITION
        });
      }
    },
    getSubjectsSelectedId(type) {
      return [
        ...new Set(this.docDigital.subjectsSelected
          .map((subject) => parseInt(subject[type].value, 10)))
      ];
    },
    async sendExpToDocDigital() {
      const isValid = await this.$validator.validateAll('send-to-docdigital-form');
      if (!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Por favor llena todos los campos para continuar',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
        return;
      }

      if (this.matterEmpty) {
        this.docDigital.matter = this.matterInput.trim();
      }

      if (!this.detailsFile.destinatarios.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Debes de agregar al menos un destinatario',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
        return;
      }

      const subjects = this.detailsFile.destinatarios.filter((subject) => subject.destinoCodigo === 'docDigital');

      this.entitiesIds = subjects
        .filter(((item) => item.estado != 2))
        .map((entity) => parseInt(entity.institucionCodigo, 10));

      const body = {
        ...(this.docDigital.documentType
          && { tipo_id: parseInt(this.docDigital.documentType, 10) }),
        ...(this.docDigital.matter && { materia: this.docDigital.matter }),
        ...(this.docDigital.matter && { descripcion: this.docDigital.matter }),
        nombre: this.detailsFile.adjuntos.find((document) => document.tipo === 'principal').adjuntoNombre,
        es_reservado: this.detailsFile.dnt.transportePuertoTipo !== '0',
        folio: this.detailsFile.numero.toString(),
        id_entidad_creadora: 306,
        listado_id_entidades_destinatarias: this.entitiesIds,
        listado_id_usuarios_destinatarios: this.getSubjectsSelectedId('subjectUser'),
        run_usuario_creador: this.detailsFile.dnt.solicitanteRut.split('-')[0],
        ...(!!this.docDigital.copiesSelected.length
          && {
            listado_correos_copia: [
              ...new Set(this.docDigital.copiesSelected
                .map((copy) => copy.subjectUser.extra.email))
            ]
          })
      };

      this.loadingToSend = true;

      const payload = {
        body,
        params: {
          metodo: 'send_expediente',
          febosId: this.file.febosId
        }

      };
      console.log('body', body);
      await this.sendToDocDigital(payload);
    },
    async loadData() {
      const documents = await listOptions({
        grupoOpcion: 'tipos.documentos-ed',
        deshabilitado: 'no',
        agrupar: 'si'
      });
      if (this.detailsFile && this.detailsFile.dnt && this.detailsFile.observaciones) {
        let document = documents.data.opciones
          .find((doc) => doc.opcionId === this.detailsFile.dnt.emisorSucursalCiudad);
        if (document) {
          document = {
            ...document,
            extra: JSON.parse(document.extra) || {}
          };
          this.docDigital.documentType = document.extra.idDocDigital;
        }
        this.docDigital.matter = this.detailsFile && this.detailsFile.observaciones && this.detailsFile.observaciones.length > 0 ? this.detailsFile.observaciones[0].observacion : '';
        this.matterEmpty = !this.docDigital.matter || !this.docDigital.matter.trim();
        this.matterInput = '';
        const subjects = this.detailsFile && this.detailsFile.destinatarios
          .filter((subject) => subject.destinoCodigo === 'docDigital');

        const entitiesSubjects = subjects
          .map((entity) => entity.institucionCodigoId);

        const entities = await listV2Options({
          grupoOpcion: 'io.doc.digital.entidades',
          deshabilitado: 'no',
          agrupar: 'si',
          filtros: `opcionId:${entitiesSubjects.toString()}`
        });

        this.entitiesIds = entities.data.opciones
          .map((entity) => ({
            ...entity,
            extra: JSON.parse(entity.extra)
          }))
          .map((extraEntity) => extraEntity.extra.entidad_id);
      }
    }
  }
};
</script>
